import type { CustomThemeConfig } from '@pba/react-theme';
import type { Space } from 'antd';
import type { ComponentProps } from 'react';
import { useResolveSpacingValue } from '../../hooks';

export type SizeValue = [SizeInput, SizeInput] | SizeInput;
type SingleSpaceSize = Exclude<SpaceAntdSize, TupleSize>;
type SizeInput = SingleSpaceSize | SpacingKey;
type SpaceAntdProperties = ComponentProps<typeof Space>;
type SpaceAntdSize = NonNullable<SpaceAntdProperties['size']>;
type SpacingKey = keyof CustomThemeConfig['spacing'];
type TupleSize = Extract<SpaceAntdSize, [unknown, unknown]>;

export const useGetSize = ({ size }: { size?: SizeValue }): SpaceAntdProperties['size'] => {
  const resolveSpacingValue = useResolveSpacingValue();

  if (!size) {
    return undefined;
  }

  return Array.isArray(size)
    ? [resolveSpacingValue({ value: size[0] }), resolveSpacingValue({ value: size[1] })]
    : resolveSpacingValue({ value: size });
};
